import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { ICompanyResponse } from '../../../core/models/company.model';
import { IAISummaryResponse, ICompanyTypesResponse, IFootprintDetailedResponse, IinnovationActivityResponse, IinnovationQualityResponse, IInventionData, IInventionDataResponse, IKeywordsResponse, IPeerGroupCompetitorsResponse, ITechnologyFootprint, ITechnologyFootprintResponse, ITopCompaniesResponse } from '../../../core/models/results.model';
import { IUniverseSelection } from 'src/app/state/app.state';


@Injectable({
  providedIn: 'root'
})
export class GeneralInnovationActivityResultsService {

  constructor(private http: HttpClient) { }


  testSearch(name: string): Observable<ICompanyResponse> {
    let params = new HttpParams()
      .set("num_matches", "100")
      .set("name", name ?? '');

    return this.http.get<ICompanyResponse>("/backend/company/search", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("current_user_token")}`,
      },
      params: params,
      responseType: "json",
    }).pipe(
      catchError(error => {
        console.error('Error occurred during test search:', error);
        return throwError(() => new Error('Error during test search.'));
      })
    );
  }


  getInnovationActivity(query: string | null | undefined, entityids: string[] | null | undefined,tabId:string): Observable<HttpResponse<IinnovationActivityResponse>> {
    return this.http.post<IinnovationActivityResponse>('/backend/results/innovation/activity', { 'query': query, 'entityids': entityids,'tabId':tabId }, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("current_user_token"),
      },
      responseType: 'json',
      observe: 'response',
    }
    )
  }

  getCompanyTypesActivity(query: string | null | undefined,tabId:string): Observable<HttpResponse<ICompanyTypesResponse>> {
    return this.http.post<ICompanyTypesResponse>('/backend/results/innovation/theme/companytypes', { 'query': query,'tabId':tabId }, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("current_user_token"),
      },
      responseType: 'json',
      observe: 'response',
    }
    )
  }


  getTechnologyFootprint(query: string | null | undefined, entityids: string[] | null | undefined,tabId:string): Observable<HttpResponse<ITechnologyFootprintResponse>> {
    return this.http.post<ITechnologyFootprintResponse>('/backend/results/innovation/techfootprint', { 'query': query, 'entityids': entityids,'tabId':tabId }, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("current_user_token"),
      },
      responseType: 'json',
      observe: 'response',
    }
    )
  }

  getKeywords(query: string | null | undefined, entityids: string[] | null | undefined,tabId:string): Observable<HttpResponse<IKeywordsResponse>> {
    return this.http.post<IKeywordsResponse>('/backend/results/innovation/keywords', { 'query': query, 'entityids': entityids,'tabId':tabId }, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("current_user_token"),
      },
      responseType: 'json',
      observe: 'response',
    }
    )
  }


  getFootprintDetailed(query: string | null | undefined, entityids: string[] | null | undefined,tabId:string): Observable<HttpResponse<IFootprintDetailedResponse>> {
    return this.http.post<IFootprintDetailedResponse>('/backend/results/innovation/footprint/detailed', { 'query': query, 'entityids': entityids,'tabId':tabId }, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("current_user_token"),
      },
      responseType: 'json',
      observe: 'response',
    }
    )
  }


  getInnovationQuality(query: string | null | undefined, entityids: string[] | null | undefined, tabId: string): Observable<HttpResponse<IinnovationQualityResponse>> {
    return this.http.post<IinnovationQualityResponse>('/backend/results/innovation/quality', { 'query': query, 'entityids': entityids, 'tabId': tabId }, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("current_user_token"),
      },
      responseType: 'json',
      observe: 'response',
    }
    )
  }

  getTopCompanies(params: {
    query: string | null | undefined,
    tabId: string,
    include_public?: boolean,
    include_private?: boolean,
    min_mcap?: number,
    max_mcap?: number
  }):  Observable<HttpResponse<ITopCompaniesResponse>> {
    return this.http.post<ITopCompaniesResponse>(
      '/backend/results/universe/top_companies',
      {
        query: params.query,
        tabId: params.tabId,
        include_public: params.include_public ?? false,
        include_private: params.include_private ?? false,
        min_mcap: params.min_mcap,
        max_mcap: params.max_mcap,
      },
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('current_user_token'),
        },
        observe: 'response',
        responseType: 'json',
      }
    );
  }


  getCompetitiveBenchmarkingPeerGroup(params: {
   universeSelection: IUniverseSelection |undefined;
}, tabId: string, entityid: string | null, gics: string | null ): Observable<HttpResponse<IPeerGroupCompetitorsResponse>> {

  // Ensure gics is a string if it's a number
  if (typeof gics === 'number') {
    gics = String(gics);
  }
    return this.http.post<IPeerGroupCompetitorsResponse>('/backend/results/universe/company/peergroup', {
      entityid: entityid,
      tabId: tabId,
      include_public: params.universeSelection?.include_public ?? false,
      include_private: params.universeSelection?.include_private ?? false,
      min_mcap: params.universeSelection?.min_mcap,
      max_mcap: params.universeSelection?.max_mcap,
      gics: gics
    }, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("current_user_token"),
      },
        observe: 'response',
      responseType: 'json',
    }
    )
  }



  getInventions(query: string | null | undefined, entityids: string[] | null | undefined, date_start: Date | null | undefined, date_end: Date | null | undefined, quality_filter: string | null | undefined, view: string, tabId: string): Observable<IInventionDataResponse> {
    return this.http.post<IInventionDataResponse>('/backend/results/inventions/data', { 'query': query, 'entityids': entityids, date_end: date_end, date_start: date_start, quality_filter: quality_filter, view: view, tabId: tabId }, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("current_user_token"),
      },
      responseType: 'json',
    }
    )
  }


  getAISummary(query: string | null | undefined, entityids: string[] | null | undefined, date_start: Date | null | undefined, date_end: Date | null | undefined, quality_filter: string | null | undefined, view: string, tabId: string): Observable<IAISummaryResponse> {
    return this.http.post<IAISummaryResponse>('/backend/siaAssistant/summary', { 'query': query, 'entityids': entityids, 'date_end': date_end, 'date_start': date_start, 'quality_filter': quality_filter, 'view': view, 'tabId': tabId }, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("current_user_token"),
      },
      responseType: 'json',
    }
    )
  }


}
